// extracted by mini-css-extract-plugin
export default {"container":"El-z","blurb":"Fl-z","links":"Gl-z"};